export function PlategiController() {
  const vm = this

  vm.nscheta = $.fn.urlparam('nscheta')
  vm.firm = $.fn.urlparam('firm')
  vm.pid = $.fn.urlparam('pid')
  vm.nomer = $.fn.urlparam('nomer')
}
